var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 4.42025C12.75 4.1441 12.4142 3.71191 12 3.71191C11.5858 3.71191 11.25 4.1441 11.25 4.42025V11.4619H4.25C3.95761 11.4619 3.5 11.7977 3.5 12.2119C3.5 12.6261 3.95761 12.9619 4.25 12.9619H11.25V20.0036C11.25 20.2797 11.5858 20.7119 12 20.7119C12.4142 20.7119 12.75 20.2797 12.75 20.0036V12.9619H19.75C20.0424 12.9619 20.5 12.6261 20.5 12.2119C20.5 11.7977 20.0424 11.4619 19.75 11.4619H12.75V4.42025Z",
    fill: "#197B6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusGreen);
export default __webpack_public_path__ + "static/media/plus-green.41172a6818738cd9d7866f1ab62f6552.svg";
export { ForwardRef as ReactComponent };